import React from 'react'

export default function ImageList({ imagesRef, data, isCurrentDuonut }) {

   return (
      <div>
         <div
            ref={imagesRef}
            className="images-div"
         >
            {isCurrentDuonut ? data.map((item) => {
               let imgData = item.theme_id?.thumbnail_data?.uri;
               return imgData ? (
                  <div className="image-div">
                     <img src={imgData} />
                  </div>
               ) : (
                  <div className="image-div">
                     <img src="/assets/theme.png" />
                  </div>
               );
            }) :
               data.map((item) => {
                  let imgData = item.uri;
                  return (
                     <div className="image-div">
                        <img src={imgData} />
                     </div>
                  )
               })
            }

         </div>
      </div>

   )
}
